import React from "react";
import {withTranslation} from "react-i18next";
import {Image, Page, Text, View} from "@react-pdf/renderer";

function HeaderPdf(props) {

    const {t, styles,stylesPdf, titlepdf, subtitle} = props;

    return (
        <Page size="A4" style={stylesPdf.page}>
            <Image src="/assets/img/backgroundpdf.png" style={stylesPdf.pageBackground} fixed/>
            <View style={stylesPdf.rowheader}>
                <View style={{flexDirection: "row"}}>
                    <View style={{width: "190px", textAlign: "left", marginLeft: 24, marginTop: 24}}>
                        <Image style={styles.imagelogoheader} src="/assets/img/logoblanco.png"/>
                    </View>
                </View>
            </View>
            <View style={{display: "flex", flexDirection: "column", alignItems: "center", margin: "auto"}}>
                <Image style={stylesPdf.imageLogoCenter} src="/assets/img/logo.png"/>
                <Image style={stylesPdf.imageReportCenter} src="/assets/img/report.png"/>
                <Text style={stylesPdf.titlePortada}>{titlepdf}</Text>
                <Text style={stylesPdf.subtitlePortada}>{subtitle}</Text>
            </View>
            <View fixed style={stylesPdf.footerFirstPage}>
                <Text>{t("contrato.footer")}</Text><Text>{t("contrato.subfooter")}</Text>
            </View>
            <Image src="/assets/img/wave-yellow-informes.png" style={stylesPdf.pageBackgroundFooter} fixed/>
        </Page>
    )}

export default withTranslation()(HeaderPdf);
